module.exports = "/_next/static/videos/lacrosse-1-d0cb68d4c12ea4efa9f4d2400e2c13a9.webm";